import React from "react";
import { ACTIONS } from "../state/contexts/quizState";
import { useQuiz } from "../services/hooks/useQuiz";

export default React.memo(function QuizQ7({ isActive }) {
  const { setAnswer, quizResponses } = useQuiz();

  const { makeupStyle } = quizResponses;

  const onAnswer = (answer) => {
    setAnswer(ACTIONS.SET_MAKEUP_STYLE, {
      makeupStyle: answer,
    });
  };

  const options = [
    {
      title: "Natural",
      text: "I usually wear a natural look.",
    },
    {
      title: "Classic",
      text: "I tend towards the traditional.",
    },
    {
      title: "Trendy",
      text: "I'm a trendsetter.",
    },
    {
      title: "Adventurous",
      text: "I will try anything.",
    },
  ];

  const listItems = options.map(({ title, text }) => (
    <div
      key={title}
      className="quiz-radio-option"
      onClick={() => onAnswer(title)}
    >
      <div className="custom-control custom-radio float-left">
        <input
          type="radio"
          id={title}
          name="makeupStyle"
          value={title}
          className="custom-control-input"
          checked={makeupStyle === title}
          onChange={(e) => {
            onAnswer(e.target.value);
          }}
        />
        <label className="custom-control-label" htmlFor={title}></label>
      </div>
      <div className="ml-8 quiz-radio-content">
        <div className="font-size-h6">{title}</div>
        <p className="text-muted">{text}</p>
      </div>
    </div>
  ));

  if (!isActive) {
    return null;
  }

  return (
    <React.Fragment>
      <h4 className="mb-8">What is your makeup style?</h4>

      <div className="quiz-radio-options">{listItems}</div>
    </React.Fragment>
  );
});
